export interface InventoryOption {
    label: string;
    value: string;
    checked?: boolean;
    isUsed?: boolean;
}

export interface InventoryOptionNotDeleted extends InventoryOption {
    isDeleted?: boolean;
}

export interface CampaignData {
    value: number | null;
    label: string | null;
    campaignUuid: string;
    languageDefault: string;
}

export enum InventoryCategory {
    product = 'product',
    paper = 'paper',
    photopass = 'photopass',
}

export const CategoryOptions: InventoryOption[] = [
    { label: 'Product', value: InventoryCategory.product, checked: false },
    { label: 'DNP media kit', value: InventoryCategory.paper, checked: false },
    { label: 'Photopass', value: InventoryCategory.photopass, checked: false },
];

export const SubPaper: InventoryOption[] = [
    // { label: 'DS620 4x6 media kit', value: 'dnp_ds620_4x6_800', checked: false },
    // { label: 'DS620 6x8 media kit', value: 'dnp_ds620_6x8_400', checked: false },
    // { label: 'RX1 4x6 media kit', value: 'dnp_rx1_4x6_700', checked: false },
    // { label: 'RX1 6x8 media kit', value: 'dnp_rx1_6x8_350', checked: false },
    { label: 'DNP RX-1 media kit', value: 'dnp_rx1', checked: false },
    { label: 'DNP DS620 media kit', value: 'dnp_ds620', checked: false },
];

export const SubPhotopass: InventoryOption[] = [
    { label: 'VIP codes', value: 'vip-photocode', checked: false },
    { label: 'Photo codes', value: 'regular-photocode', checked: false },
];
